export const cssBundleHref = "/build/css-bundle-NC7LNF66.css";